import React from 'react';
import { Page } from '../page/page';
import { VocabularyForm } from './vocabulary-form';
import environment from '../../lib/RelayUtils';
import { commit } from './mutations/vocabulary-add';
import { withRouter } from 'react-router-dom';

export const VocabularyCreate = withRouter(props => {
	const { history } = props;

	const onSubmit = submitted => {
		if (!submitted.description) {
			submitted.description = '';
		}
		submitted.canDelete = false;
		commit(environment, submitted, (error: ?Error) => {
			if (error) {
				console.log(error);
			} else {
				history.push(`/vocabulary`);
			}
		});
	};

	return (
		<Page title="Справочник">
			<VocabularyForm onSubmit={onSubmit} />
		</Page>
	);
});



// WEBPACK FOOTER //
// src/components/vocabulary/vocabulary-create.js